import { CloseOutlined } from '@ant-design/icons';
import { Button, Spin } from 'antd';
import StudentTaskDetailContent from 'src/components/studentPages/StudentTaskDetail/_StudentTaskDetailContent/StudentTaskDetailContent';
import { StyledPreviewTask } from './PreviewTask.styled';

export default function PreviewTask({ task, onClose, loading }) {
  return (
    <StyledPreviewTask
      visible={task}
      centered
      closable={false}
      width="100%"
      height="100%"
      destroyOnClose
      footer={[
        <Button key="close" onClick={onClose} icon={<CloseOutlined />}>
          Close
        </Button>,
      ]}
    >
      {loading ? (
        <Spin spinning />
      ) : (
        <StudentTaskDetailContent task={task} isPreview />
      )}
    </StyledPreviewTask>
  );
}
